import _ from 'lodash';

const toSnakeCase = (str) => {
  return str
    .replace(/([a-z\d])([A-Z])/g, '$1_$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .toLowerCase();
};

const deepSnakeizeKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(deepSnakeizeKeys);
  } else if (_.isPlainObject(obj)) {
    return _.mapKeys(_.mapValues(obj, deepSnakeizeKeys), (v, k) => toSnakeCase(k));
  }
  return obj;
}

export default deepSnakeizeKeys;
